"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Options = void 0;
const selector_1 = require("@pulse-web-ui/selector");
const spinner_1 = require("@pulse-web-ui/spinner");
const theme_1 = require("@pulse-web-ui/theme");
const react_1 = __importStar(require("react"));
const options_styles_1 = require("./options.styles");
require("./options.types");
const Check = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@pulse-web-ui/icons/lib/lazy/check'))));
const Options = ({ options, onOptionClick, isLoading, isMultiSelect, assistiveText, testId = 'options', }) => {
    const theme = (0, theme_1.useTheme)();
    const emptyOptionsElement = (0, react_1.useMemo)(() => isLoading ? (react_1.default.createElement(options_styles_1.EmptyOptionsElement, null,
        "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430",
        react_1.default.createElement(spinner_1.Spinner, { color: theme.colors.icon.quaternary }))) : (react_1.default.createElement(options_styles_1.EmptyOptionsElement, null, "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E")), [isLoading]);
    return (react_1.default.createElement(options_styles_1.OptionsList, { hasAssistiveText: !!assistiveText, "data-testid": testId },
        assistiveText && react_1.default.createElement(options_styles_1.AssistiveText, null, assistiveText),
        !(options === null || options === void 0 ? void 0 : options.length)
            ? emptyOptionsElement
            : options.map((option) => (react_1.default.createElement(options_styles_1.OptionItem, { key: `${option.label}${option.value}`, onClick: () => onOptionClick && onOptionClick(option), selected: option.selected, isMultiSelect: !!isMultiSelect, "data-testid": `${testId}.${option.value}` },
                react_1.default.createElement(options_styles_1.OptionLabel, null,
                    option.label,
                    option.description && (react_1.default.createElement(options_styles_1.OptionItemDescription, null, option.description))),
                react_1.default.createElement(options_styles_1.OptionIcon, { onClick: (e) => e.preventDefault() }, isMultiSelect ? (react_1.default.createElement(selector_1.Selector, { checked: option.selected, readOnly: true })) : option.selected ? (react_1.default.createElement(react_1.Suspense, { fallback: null },
                    react_1.default.createElement(Check, { color: theme.colors.text.interactive, width: 18 }))) : null))))));
};
exports.Options = Options;
